import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
import styled, { createGlobalStyle } from 'styled-components';
import { mediaMin, tabletRange } from '@spa/shared/theme';
import { Box } from '@spa/shared/components/Modal/styles';
import { Wrapper as Button } from '@spa/shared/components/Unisystem/Button/styles';
import { Wrapper as StatusBanner } from '@spa/shared/components/Unisystem/StatusBanner/styles';
export var ModalGlobalStyle = /*#__PURE__*/createGlobalStyle([".social-share{", "{display:flex;flex-direction:column;position:relative;", " ", "{--paddings:32px;position:absolute;bottom:calc(var(--paddings) / 2);left:var(--paddings);width:calc(100% - var(--paddings) * 2);}", "}}"], Box, tabletRange.ipad()(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        width: 55%;\n      "]))), StatusBanner, mediaMin.mediumBreakpoint(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        width: 100%;\n        height: 100vh;\n        max-width: 100vw;\n        max-height: 100vh;\n        overflow-y: auto;\n\n        ", " {\n          bottom: unset;\n          top: calc(100vh - 162px);\n        }\n      "])), StatusBanner));
export var Header = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-7feiy6-0"
})(["display:flex;align-items:center;width:100%;", ";margin-bottom:", ";", ""], function (props) {
  return props.theme.gap(5);
}, function (props) {
  return props.theme.space(3);
}, mediaMin.smallBreakpoint(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref) {
  var theme = _ref.theme;
  return theme.gap(2);
}));
export var Info = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-7feiy6-1"
})(["display:flex;flex-direction:column;", ";"], function (props) {
  return props.theme.gap(1);
});
export var Title = /*#__PURE__*/styled.p.withConfig({
  componentId: "sc-7feiy6-2"
})(["font-size:", ";line-height:", ";font-weight:600;", ""], function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(20);
}, mediaMin.smallBreakpoint(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  "]))));
export var Subtitle = /*#__PURE__*/styled.p.withConfig({
  componentId: "sc-7feiy6-3"
})(["font-size:", ";line-height:", ";font-weight:400;color:", ";"], function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(20);
}, function (props) {
  return props.theme.shareModal.subtitle;
});
export var Photo = /*#__PURE__*/styled.img.withConfig({
  componentId: "sc-7feiy6-4"
})(["width:200px;height:120px;object-fit:cover;border-radius:8px;", ""], mediaMin.smallBreakpoint(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    width: 100px;\n    height: 100px;\n    aspect-ratio: 1;\n  "]))));
export var Buttons = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-7feiy6-5"
})(["display:grid;grid-template-columns:repeat(2,1fr);gap:", ";width:100%;position:relative;z-index:0;", "{display:flex;align-items:center;& > span{display:flex;align-items:center;width:100%;", ";position:relative;z-index:0;& > div{padding-left:", ";}svg{flex:0 0 31px;width:31px;height:31px;align-content:center;}}}", ""], function (props) {
  return props.theme.space(5);
}, Button, function (props) {
  return props.theme.gap(3);
}, function (props) {
  return props.theme.space(3);
}, mediaMin.smallBreakpoint(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    grid-template-columns: repeat(1, 1fr);\n  "]))));